var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContactMultiple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1286_14881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.875H15V10.625H2.5V1.875ZM13.75 9.375V3.125H3.75V9.375H13.75ZM12.5 11.875H1.25V4.375H0V13.125H12.5V11.875ZM5.625 4.375H6.875V5.625H5.625V4.375ZM7.5 6.875H5V8.125H7.5V6.875ZM8.75 4.375H12.5V5.625H8.75V4.375ZM12.5 6.875H8.75V8.125H12.5V6.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1286_14881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContactMultiple);
export default __webpack_public_path__ + "static/media/ic_contact_multiple.2d0a1e0d1df48d483187269a31fbc261.svg";
export { ForwardRef as ReactComponent };